module.exports = __webpack_public_path__ + "static/media/burger.bd2c9dac.svg";